<div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
        <span class="custom-text">{{ 'addYourOwnFlux' | transloco }}</span>
        <div class="flex items-stretch gap-3">
            <div
                class="flex min-h-12 w-48 items-center"
                [class]="addLayerService.selectedServiceCatalogs().length ? 'pointer-events-none opacity-50' : ''">
                <app-select
                    class="block w-full"
                    [defaultValue]="selectedFluxTypeOption()"
                    [enableSort]="false"
                    [isDisabled]="!!addLayerService.selectedServiceCatalogs().length"
                    [isSimpleSelectStyle]="true"
                    [options]="fluxTypeOptions"
                    [placeholder]="'fluxType'"
                    (optionSelected)="selectFluxType($event)" />
            </div>
            <div class="flex min-h-12 flex-1 items-center">
                <app-input-text
                    class="block w-full pt-0"
                    [additionalClasses]="'w-full'"
                    [disabled]="!!addLayerService.selectedServiceCatalogs().length"
                    [errors]="
                        addLayerService.sourceUrlControl?.getError('invalid')
                            ? [addLayerService.sourceUrlControl!.getError('invalid')]
                            : []
                    "
                    [inputFormControl]="addLayerService.sourceUrlControl"
                    [placeholder]="'enterLink' | transloco"
                    (onValueChange)="onValueChange($event)" />
            </div>
        </div>
    </div>

    @if (isLoading()) {
        <app-loading />
    } @else {
        <div [class]="isManualSelectionActive() ? 'pointer-events-none opacity-50' : ''">
            @if (serviceCatalogsByTopic().length) {
                <app-tab
                    [activeTabColor]="'bg-custom-light-grey'"
                    [defaultTabIndex]="selectedTabIndex()"
                    [isSimpleTabStyle]="true"
                    [tabs]="themeTabs()"
                    [tabsBadge]="tabsBadge()"
                    [translateTabs]="false"
                    (changeTab)="changeTab($event)">
                    @for (item of serviceCatalogsByTopic(); track item.topicName) {
                        <ng-template appTabContent>
                            <div
                                class="max-h-[35vh] overflow-x-hidden overflow-y-auto rounded-lg bg-custom-light-grey p-2.5">
                                @for (serviceCatalog of item.serviceCatalogs; track serviceCatalog.id) {
                                    <div class="mb-2 bg-white rounded-2xl">
                                        <app-expansion-panel [isExpanded]="false">
                                            <div
                                                class="flex items-center gap-3 pr-4"
                                                header>
                                                <div class="flex items-center gap-3 min-w-0">
                                                    <div
                                                        class="shrink-0"
                                                        (click)="
                                                            $event.stopPropagation();
                                                            toggleServiceCatalogSelected(serviceCatalog)
                                                        ">
                                                        <app-checkbox
                                                            [checkboxState]="
                                                                isSelected(serviceCatalog.id)
                                                                    ? CheckboxState.CHECKED
                                                                    : CheckboxState.UNCHECKED
                                                            "
                                                            [disabled]="isManualSelectionActive()" />
                                                    </div>
                                                    <p class="text-xl font-normal truncate">
                                                        {{ serviceCatalog.layerName }} ({{
                                                            serviceCatalog.serviceType
                                                        }})
                                                    </p>
                                                </div>
                                            </div>

                                            <div
                                                class="w-11/12 m-auto pb-4 pt-1"
                                                content>
                                                <div class="flex flex-col gap-3">
                                                    <div>
                                                        <p class="font-medium">{{ 'dataSource' | transloco }}</p>
                                                        <p class="text-custom-dark-grey text-sm font-normal">
                                                            {{ serviceCatalog.dataSupplier || '-' }}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p class="font-medium">{{ 'description' | transloco }}</p>
                                                        <p class="text-custom-dark-grey text-sm font-normal">
                                                            {{ serviceCatalog.description || '-' }}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p class="font-medium">{{ 'informationUrl' | transloco }}</p>
                                                        <a
                                                            class="text-sm break-all text-custom-blue"
                                                            rel="noreferrer"
                                                            target="_blank"
                                                            [href]="
                                                                serviceCatalog.aboutUrl || serviceCatalog.sourceUrl
                                                            ">
                                                            {{ serviceCatalog.aboutUrl || serviceCatalog.sourceUrl }}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </app-expansion-panel>
                                    </div>
                                } @empty {
                                    <div class="p-4 text-custom-dark-grey">
                                        {{ 'noFluxData' | transloco }}
                                    </div>
                                }
                            </div>
                        </ng-template>
                    }
                </app-tab>
            } @else {
                <div class="rounded-lg bg-custom-light-grey p-4 text-custom-dark-grey">
                    {{ 'noFluxData' | transloco }}
                </div>
            }
        </div>
    }

    @if (isGetLayersFromUrlLoading()) {
        <app-loading />
    } @else if (addLayerService.sourceUrlControl && addLayerService.sourceUrlControl.invalid) {
        <span class="custom-text">{{ 'noFluxData' | transloco }}</span>
    }
</div>
